import React, { useState, useEffect } from 'react';
import './NavDrawer.css';
import "../../index.css"

const items = [
  { label: 'Home', path: '/' },
  { label: 'Portraits', path: '/portrait' 
    // children: 
    // [
    // { label: 'Wedding', path: '/film/wedding' },
    // { label: 'Documentary', path: '/film/documentary' },
    // ]
},
  { label: 'Commercial', path: '/commercial' },
  // { label: 'Cinematic', path: '/cinematic' }
];

const NavDrawer = ({ open, onClose, onNavigate, clr = "white" }) => {
  const [expanded, setExpanded] = useState({});

  useEffect(() => {
    if (!open) setExpanded({});
  }, [open]);

  const toggle = (idx) => {
    setExpanded(prev => ({ ...prev, [idx]: !prev[idx] }));
  };

  const handleNavigate = (path) => {
    onNavigate(path);
    onClose();
  };

  return (
    <div className={`nav-drawer-root ${open ? 'open' : ''}`} aria-hidden={!open}>
      <div className="nav-drawer-overlay" onClick={onClose} />

      <aside className={`nav-drawer ${open ? 'open' : ''}`} role="dialog" aria-modal="true">
        <button className={`drawer-close ${clr && clr} drawer-expand`} onClick={onClose} aria-label="close">×</button>

        <ul className="drawer-list">
          {items.map((it, idx) => (
            <li key={idx} className={`drawer-item ${clr && clr}`}>
              <div className="drawer-item-main">
                <button className={`drawer-link ${clr && clr} margin-bottom-3`} onClick={() => it.children ? toggle(idx) : handleNavigate(it.path)}>
                  {it.label}
                </button>
                {it.children && (
                  <button className={`drawer-expand ${clr && clr} font-size-1`} onClick={() => toggle(idx)} aria-label="expand">{expanded[idx] ? '−' : '+'}</button>
                )}
              </div>
              {it.children && expanded[idx] && (
                <ul className={`drawer-sublist ${clr && clr}`}>
                  {it.children.map((c, ci) => (
                    <li key={ci}>
                      <button className={`drawer-sublink ${clr && clr} bg-dark-blue`} onClick={() => handleNavigate(c.path)}>{c.label}</button>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </aside>
    </div>
  );
};

export default NavDrawer;
